import React from 'react';

// Dependencies
import { parseISO } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import { readableMinutes } from '../../../helpers/helpers';

// Components
import Tooltip from '../../common/Tooltip';
import * as icons from '../../ui/Icons';
import ShareVideo from './ShareVideo';

class Overview extends React.Component {
  /**
   * Render individual premitted item info
   *
   * @function renderItem
   * @param {string} label
   * @param {string} note
   * @returns {element}
   */
  renderItem(label, note) {
    return (
      <span className="tooltip-wrap">
        {label}

        {note &&
          <Tooltip
            id={`permitted-item-${label.split(' ').join('-')}`}
            content={note}
            variation="left"
          />
        }
      </span>
    );
  }

  /**
   * Show a note if facial processing was disabled
   *
   * @function renderAIDisabled
   * @param {array} annotations
   * @returns {element}
   */
  renderAIDisabled = annotations => {
    const { translation } = this.props;

    const wasDisabled = annotations.filter(annotation => {
      return annotation.title === 'facial_processing_disabled';
    }).length > 0;

    if (wasDisabled) {
      return (
        <li className="data__highlight">
          <strong>{translation.note}</strong>
          <span>
            {translation.ai_disabled}
          </span>
        </li>
      )
    }
  }


  render() {
    const { session, store, translation } = this.props;
    const { timeZone, sharedViewer } = store.AppStore;
    const { appointmentDate, examConfiguration } = session;

    return (
      <section>
        <h2 className="meta">{translation.title}</h2>

        <ul className="data data--separate">
          <li>
            <strong>{translation.date}</strong>

            <span>
              {format(
                utcToZonedTime(
                  parseISO(appointmentDate), timeZone
                ), 'M/d/yyyy h:mm a z'
              )}
            </span>
          </li>

          <li>
            <strong>{translation.duration}</strong>

            <span>
              {readableMinutes(examConfiguration.duration, translation.time_labels)}
            </span>
          </li>

          <li>
            <strong>{translation.status}</strong>

            <span>
              {session.status}
            </span>
          </li>

          <li>
            <strong>{translation.permitted_items}</strong>

            {
              !examConfiguration.permittedBathroomBreak &&
              !examConfiguration.permittedBlankPaper &&
              !examConfiguration.permittedCalculator &&
              !examConfiguration.permittedDictionary &&
              !examConfiguration.permittedEarplugs &&
              !examConfiguration.permittedFormulaSheet &&
              !examConfiguration.permittedNotes &&
              !examConfiguration.permittedTextbook &&
              !examConfiguration.permittedWebsites &&
              !examConfiguration.permittedOtherItems &&

              <span>{translation.none}</span>
            }

            {(
              examConfiguration.permittedBathroomBreak ||
              examConfiguration.permittedBlankPaper ||
              examConfiguration.permittedCalculator ||
              examConfiguration.permittedDictionary ||
              examConfiguration.permittedEarplugs ||
              examConfiguration.permittedFormulaSheet ||
              examConfiguration.permittedNotes ||
              examConfiguration.permittedTextbook ||
              examConfiguration.permittedWebsites ||
              examConfiguration.permittedOtherItems
            ) &&
              <div>
                {examConfiguration.permittedBathroomBreak &&
                  this.renderItem(
                    translation.bathroom_break,
                    examConfiguration.permittedBathroomBreakInformation)}
                {examConfiguration.permittedBlankPaper &&
                  this.renderItem(
                    translation.blank_paper,
                    examConfiguration.permittedBlankPaperInformation)}
                {examConfiguration.permittedCalculator &&
                  this.renderItem(
                    translation.calculator,
                    examConfiguration.permittedCalculatorInformation)}
                {examConfiguration.permittedDictionary &&
                  this.renderItem(
                    translation.dictionary,
                    examConfiguration.permittedDictionaryInformation)}
                {examConfiguration.permittedEarplugs &&
                  this.renderItem(
                    translation.earplugs,
                    examConfiguration.permittedEarplugsInformation)}
                {examConfiguration.permittedFormulaSheet &&
                  this.renderItem(
                    translation.formula_sheet,
                    examConfiguration.permittedFormulaSheetInformation)}
                {examConfiguration.permittedNotes &&
                  this.renderItem(
                    translation.notes,
                    examConfiguration.permittedNotesInformation)}
                {examConfiguration.permittedTextbook &&
                  this.renderItem(
                    translation.textbook,
                    examConfiguration.permittedTextbookInformation)}
                {examConfiguration.permittedWebsites &&
                  this.renderItem(
                    translation.websites,
                    examConfiguration.permittedWebsitesInformation)}
                {examConfiguration.permittedOtherItems &&
                  this.renderItem(
                    translation.other,
                    examConfiguration.permittedOtherItems)}
              </div>
            }
          </li>
          <li>
            <strong>{translation.system_check_started}</strong>
            {session.systemCheckStartDate &&
              <span>
                {format(
                  utcToZonedTime(
                    parseISO(session.systemCheckStartDate), timeZone
                  ), 'M/d/yyyy h:mm a z'
                )}
              </span>
            }

            {!session.systemCheckStartDate &&
              <span>{translation.not_started}</span>
            }
          </li>
          <li>
            <strong>{translation.system_check_completed}</strong>
            {session.systemCheckEndDate &&
              <span>
                {format(
                  utcToZonedTime(
                    parseISO(session.systemCheckEndDate), timeZone
                  ), 'M/d/yyyy h:mm a z'
                )}
              </span>
            }

            {!session.systemCheckEndDate &&
              <span>{translation.not_completed}</span>
            }
          </li>

          {this.renderAIDisabled(session.automated.annotations)}
        </ul>
      </section>
    )
  }
}

export default Overview;
